
import { createRouter, createWebHistory } from 'vue-router'
import { useAuthStore } from '@/auth/auth'

import Home from '@/views/admin/Home.vue'
import DashboardUserView from '@/views/DashboardUserView.vue'


const router = createRouter({
  history: createWebHistory(),
  routes: [
    {
      path: '/',
      name: 'landing',
      component: () => import('@/views/pages/Landing.vue')
    },
    {
      path: '/dashboard',
      component: Home,
      meta: {requiresAuth: true}
    },
    { path: '/student/studentlist',
      component: () => import('@/views/admin/StudentView.vue')
    },
    {
      path: '/school',
      name: 'school',
      component: () => import('@/views/admin/SchoolView.vue')
    },

    {
      path: '/parent/profile/:id',
      name: 'Parent Profile',
      component: () => import('@/views/admin/Parents/ParentProfileView.vue')
    },
    {
      path: '/parent',
      name: 'Parents Management',
      component: () => import('@/views/admin/Parents/ParentView.vue')
    },
    {
      path: '/security',
      name: 'Security Management',
      component: () => import('@/views/admin/SecurityPage.vue')
    },
    {
      path: '/childperformance',
      name: 'Child Performance',
      component: () => import('@/views/Parents/ChildsPerformanceSummary.vue')
    },
    {
      path: '/notfound',
      name: 'notfound',
      component: () => import('@/views/pages/NotFound.vue')
    },
    {
      path: '/tree',
      name: 'tree',
      component: () => import('@/components/admin/DivisionTreeRanking.vue')
    },
    {
      path: '/chat',
      name: 'chat',
      component: () => import('@/views/admin/ChatBoxView.vue')
    },
    {
      path: '/userchat',
      name: 'User Chat',
      component: () => import('@/views/admin/ChatUserBoxView.vue')
    },
    {
      path: '/needs',
      name: 'Dropdown Manager',
      component: () => import('@/components/admin/Needs.vue')
    },
    {
      path: '/sched',
      name: 'sched',
      component: () => import('@/components/admin/Schedulepage.vue')
    },
    {
      path: '/staff',
      name: 'staff',
      component: () => import('@/views/admin/StaffView.vue')
    },
    {
      path: '/calendar',
      name: 'calendar',
      component: () => import('@/views/admin/CalendarView.vue')
    },
    {
      path: '/office',
      name: 'office',
      component: () => import('@/components/admin/OfficeHours.vue')
    },
    {
      path: '/extra',
      name: 'Extracurricular Management',
      component: () => import('@/components/admin/ExtraCurricular.vue')
    },
    {
      path: '/break',
      name: 'break',
      component: () => import('@/components/admin/BreakTime.vue')
    },
    {
      path: '/rights',
      name: 'Rights Access',
      component: () => import('@/components/admin/RightsPage.vue')
    },
    {
      path: '/staff/add',
      name: 'Add Staff',
      component: () => import('@/views/admin/AddStaffView.vue')
    },
    {
      path: '/staff/profile/:id',
      name: 'Staff Profile',
      component: () => import('@/views/admin/StaffProfileView.vue'),
    },
        {
      path: '/userdashboard',
      name: 'Dashboard',
      component:  DashboardUserView,
    },
    {
      path: '/school/profile/:id',
      name: 'School Profile',
      component: () => import('@/views/admin/School/SchoolProfileView.vue'),
    },

    {
      path: '/set-password/:id',
      name: 'setpassword',
      component: () => import('@/views/pages/auth/SetPassword.vue')
    },
    {
      path: '/auth/login',
      name: 'login',
      component: () => import('@/views/pages/auth/Login.vue'),
    },
    {
      path: '/signup',
      name: 'signup',
      component: () => import('@/views/pages/auth/Signup.vue'),
    },
    {
      path: '/classeslist',
      name: 'Classes List',
      component: () => import('@/views/admin/Class/ClassScheduleView.vue'),
    },

    { path: '/gender/add',
      component: () => import('@/views/admin/gender/AddGender.vue'),
      },
      { path: '/role/add',
      component: () => import('@/views/admin/roles/AddRoles.vue'),
      },
      { path: '/employment/add',
      component: () => import('@/views/admin/employment/AddEmployment.vue'),
      },
      { path: '/certication/add',
      component: () => import('@/views/admin/education/AddCertification.vue'),
      },
      { path: '/qualification/add',
      component: () => import('@/views/admin/education/AddQualification.vue'),
      },
      { path: '/gender/edit/:id',
      component: () => import('@/views/admin/gender/EditGender.vue'),
      },
      {
      path: '/gender/genderlist',
      name: 'genderview',
      component: () => import('@/views/admin/GenderView.vue'),
      props: true
      },
      {
      path: '/employment/employmentlist',
      name: 'employmentview',
      component: () => import('@/views/admin/EmploymentView.vue'),
      props: true
      },

      {
      path: '/student/studentcalendar',
      name: 'studentcalendar',
      component: () => import('@/views/admin/StudentCalendar.vue'),
      props: true
      },
      {
      path: '/specialization/specializationlist',
      name: 'Specialization Management',
      component: () => import('@/views/admin/SpecializationView.vue'),
      props: true
      },
      {
      path: '/certification/certificationlist',
      name: 'certificationview',
      component: () => import('@/views/admin/EducationCertificationView.vue'),
      props: true
      },

      {
      path: '/eduqualification/eduqualificationlist',
      name: 'qualificationview',
      component: () => import('@/views/admin/EducationQualificationView.vue'),
      props: true
      },
      {
      path: '/schoolyear',
      name: 'School Year',
      component: () => import('@/components/admin/SchoolYear.vue'),
      props: true
      },

      {
      path: '/adminreport',
      name: 'Admin report',
      component: () => import('@/views/admin/AdminReport.vue'),
      props: true
      },
      {
      path: '/report/studentreport',
      name: 'studentreport',
      component: () => import('@/views/admin/StudentReport.vue'),
      props: true
      },
      {
      path: '/classroom/classroomlist',
      name: 'Classroom Management',
      component: () => import('@/components/admin/CreateClassRoomView.vue'),
      props: true
      },
      {
      path: '/role/rolelist',
      name: 'roleview',
      component: () => import('@/views/admin/RolesView.vue'),
      props: true
      },

      {
      path: '/batchupload',
      name: 'Batch Upload',
      component: () => import('@/views/admin/BatchUploadView.vue'),
      props: true
      },
    {
      path: '/student/profile/:id',
      name: 'Student Profile',
        component: () => import('@/views/admin/StudentProfile.vue'),
      props: true
    },
    {
      path: '/gender/editgender/:id',
      //path: '/studentprofile',
      name: 'editgender',
      component: () => import('@/views/admin/gender/EditGender.vue'),
      props: true
      },
      {
      path: '/employment/editemployment/:id',
      name: 'editemployment',
      component: () => import('@/views/admin/employment/EditEmployment.vue'),
      props: true
      },

      {
      path: '/role/editrole/:id',
      name: 'editrole',
      component: () => import('@/views/admin/roles/EditRoles.vue'),
      props: true
      },
      {
      path: '/certification/editcertification/:id',
      name: 'editcertification',
      component: () => import('@/views/admin/education/EditCertification.vue'),
      props: true
      },
      {
      path: '/qualification/editqualification/:id',
      name: 'editqualification',
      component: () => import('@/views/admin/education/EditQualification.vue'),
      props: true
      },
    {
      //path: '/student/:id',
      path: '/student/add',
      name: 'Add Student',
        component: () => import('@/views/admin/AddStudent.vue'),
      props: true
    },

  ],
})
router.beforeEach(async (to, from, next) => {
  const authStore = useAuthStore();

  const publicRoutes = ['/', '/auth/login', '/signup', '/set-password'];

  if ((to.path === '/auth/login' || to.path === '/') && authStore.isAuthenticated) {
    next(authStore.isAdmin ? '/dashboard' : '/userdashboard');
    return; // Stop the guard here
  }

  if (!authStore.isAuthenticated) {

    const isExactPublicRoute = publicRoutes.includes(to.path);

    const isParameterizedPublicRoute = to.path.startsWith('/set-password/');

    if (isExactPublicRoute || isParameterizedPublicRoute) {
      next();
      return;

    } else {
      next('/auth/login');
      return;
    }
  }

  next();
});

export default router

